import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import AutoScroll from 'embla-carousel-auto-scroll';
// import ClassNames from 'embla-carousel-class-names';
import Fade from 'embla-carousel-fade';
// import EmblaAutoHeight from 'embla-carousel-auto-height';
// import { addEmblaDotClickHandlers, addEmblaPrevNextClickHandlers } from './plugins/EmblaCarouselFeatures.js';

const initEmblaCarousel = () => {
	// Index About
	const emblaIAbout = document.querySelector('.embla-iabout');
	if (emblaIAbout) {
		const emblaNode = emblaIAbout.querySelector('.embla__viewport');

		const autoplay = Autoplay({ playOnInit: true });

		const emblaApi = EmblaCarousel(emblaNode, { loop: true }, [autoplay]);

		const tabs = document.querySelectorAll('.iabout-tab > li');

		tabs.forEach((tab, index) => {
			tab.addEventListener('mouseenter', () => {
				emblaApi.scrollTo(index);
				autoplay.stop();
			});
		});

		const updateEmbla = () => {
			const selectIndex = emblaApi.selectedScrollSnap();
			console.log(selectIndex);
			tabs.forEach((tab, index) => {
				tab.classList.toggle('current', index === selectIndex);
			});
		};

		emblaApi.on('init', updateEmbla).on('select', updateEmbla);
	}

	const emblaPlatform = document.querySelector('.embla-platform');
	if (emblaPlatform) {
		const emblaNode = emblaPlatform.querySelector('.embla__viewport');

		const emblaApi = EmblaCarousel(emblaNode, { loop: true, align: 'center' });
	}

	const emblaPartner = document.querySelector('.embla-partner');
	if (emblaPartner) {
		const emblaNode = emblaPartner.querySelector('.embla__viewport');

		const emblaApi = EmblaCarousel(emblaNode, { loop: true, align: 'center' });
	}
};

export { initEmblaCarousel };
